import { utils, ls } from 'passiv-libs'

export const setUrls = val => {
  if (process.env.NODE_ENV === 'production') {
    ls.set('settings.assetUrl', `${val}/passivlivingconsumer/`)
  }
  ls.set('settings.serverUrl', val)
}

export const setAccount = data => {
  // NB could store address and postcode in config
  ls.set('account.hubType', data.hubType)
  ls.set('account.heatingType', data.heatingType)
  // ls.set('account.zones', data.zones)
  ls.set(
    'account.capabilities',
    data._embedded.capabilities.map(cap => cap.id)
  )
}

export const setAuthDetails = ({ token, server, username: _username, autoLogin }) => {
  if (autoLogin) {
    ls.set('auth.type', 'Bearer')
    ls.set('auth.token', token)
  } else {
    sessionStorage.setItem('auth', JSON.stringify({ type: 'Bearer', token }))
  }
  ls.set('settings.serverUrl', server)

  // DEV-27944: Sometimes support needs to login to the app with real consumer
  // They use the username esb_ops_admin_@@@@@@_<plc_username> and the esb_ops_admin password
  // SSO then returns the oauth token for plc_username
  const usernames = _username.split('_@@@@@@_')
  const username = usernames.length > 1 ? usernames[1] : _username
  // From then on the app should use plc_username as the username
  window.config.username = username.trim() // ls.set('settings.username', username)
}

// NB could store emailAddress in config
// export const setUserEmailAddress = data => {
//   ls.set('settings.emailAddress', data.email)
// }

export const setHomeHubId = data => {
  ls.set('account.homeId', data.homeId)
  ls.set('account.hubId', data.hubId)
}

export const toggleAutoLogin = bool => {
  ls.set('settings.autoLogin', bool)
}

export const clearUserData = () => {
  window.config.eventPollSid = -1
  
  const assetUrl = ls.get('settings.assetUrl')
    ? ls.get('settings.assetUrl')
    : utils.cordova.isCordova()
    ? 'https://www.passivliving.com/passivlivingconsumer/'
    : ''

  const serverUrl = ls.get('settings.serverUrl')
    ? ls.get('settings.serverUrl')
    : utils.cordova.isCordova()
    ? 'https://www.passivliving.com'
    : ''

  const autoLogin = !!ls.get('settings.autoLogin')
  const energyPricesSet = ls.get('settings.energyPricesSet') || false
  const hasSeenWelcomeModal = ls.get('settings.hasSeenWelcomeModal') || false
  const tipsDismissed = ls.get('tipsDismissed') || []

  ls.remove('account', 'auth', 'settings')
  sessionStorage.clear()

  ls.set('settings.autoLogin', autoLogin)
  ls.set('settings.assetUrl', assetUrl)
  ls.set('settings.serverUrl', serverUrl)
  ls.set('settings.energyPricesSet', energyPricesSet)
  ls.set('settings.hasSeenWelcomeModal', hasSeenWelcomeModal)
  ls.set('settings.tipsDismissed', tipsDismissed)
}

export const setHitachiSEIProject = res => {
  // const bool = res.some(service => service.serviceType === 'zwave_hub_platform')
  const bool = res.some(service => service.serviceType === 'hitachi_sei_project')
  ls.set('account.hitachiSEIProject', bool)
}
